import * as React from 'react';
import {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import Formatter from '../../../util/formatter';
import {useTranslation} from 'react-i18next';
import useOpenState from '../../../hooks/useOpenState';
import {ColumnTypes} from './../hl7/hl7_messages_comp';
import ColumnsManager, {getColumns} from './../hl7/columns_manager';
import {useSelector} from 'react-redux';
import {agylePref} from '../../../store/reducers/preferences';
import _ from 'lodash';
import AuditsTable from './audits_table';


const AuditReports = forwardRef((props, ref) => {

    const {t} = useTranslation();
    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);

    const [selectedRow, setSelectedRow] = React.useState(null);

    const [detailsModalIsVisible, setDetailsModalIsVisible] = useState(false);
    const [detailsMessage, setDetailsMessage] = useState(null);
    const tableRef = React.useRef(null);
    useImperativeHandle(ref, () => ({
        exportCsv: () => {
            return tableRef.current.exportCsv();
        },
    }));
    const openMessageDetails = (message) => {
        setDetailsMessage(message)
        setDetailsModalIsVisible(true);
    }

    const agylePreference = useSelector(agylePref);
    const [columns, setColumns] = React.useState([])

    useEffect(()=>{
        setColumns(getColumns(columnsInit, agylePreference?.inMessageColumnOrder));
    },[agylePreference, props.timeInUtc]);

    const openJsonModal = (row) => {
        if(row.message) {
            setSelectedRow(row)
            openModal();
        } else {

        }
    }


    const columnsInit = [
        {
            name: 'date',
            order: 1,
            value: '_createdDate',
            type: ColumnTypes.TEXT,
            description: 'Date',
            minWidth: 30,
            sort:true,
            format: (value) => {
                return props.timeInUtc? Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss",""): Formatter.LocalFormatData(value,"YYYY-MM-DD HH:mm:ss");
            }
        },
        {
            name: 'action',
            order: 1,
            value: 'auditTypeDescription',
            type: ColumnTypes.TEXT,
            description: 'Action',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'userName',
            order: 1,
            value: 'userName',
            type: ColumnTypes.TEXT,
            description: 'userName',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'patientId',
            order: 1,
            value: 'patient_id',
            type: ColumnTypes.TEXT,
            description: 'MRN/Hospital Number',
            minWidth: 10,
            maxWidth: 175
        },
        {
            name: 'studyId',
            order: 1,
            value: 'studyId',
            type: ColumnTypes.TEXT,
            description: 'Study Id',
            minWidth: 10,
            maxWidth: 175
        },
        {
            name: 'documentId',
            order: 1,
            value: 'documentExternalId',
            type: ColumnTypes.TEXT,
            description: 'Document Id',
            minWidth: 10,
            maxWidth: 175
        }

    ];

    const handleCloseMessageDetails = () =>{
        setDetailsModalIsVisible(false);
    }

    const getMessage = (row) => {
        return row.message
    }

    const sortColumn = () => {
        const filteredColumns = _.filter(columns, col => {
            return !_.isNil(col.order);
        });

        return _.sortBy(filteredColumns, obj => {
            return obj.order;
        });
    };


    const [openConfig, setOpenConfig] = React.useState(false);

    return (<div>

        {/*<IconButton*/}
        {/*    size={"small"}*/}
        {/*    disableRipple={true}*/}
        {/*    onClick={() => setOpenConfig(true)}>*/}
        {/*    <SettingsIcon/>*/}
        {/*</IconButton>*/}

        <ColumnsManager prefPath={"inMessageColumnOrder"}
                        columns = {columns}
                        title={"Incoming Messages Columns Settings"}
                        columnsInit = {columnsInit}
                        openConfig={openConfig}
                        closeModal={() => setOpenConfig(false)}/>

        <AuditsTable ref={tableRef} table = {"hl7Log"} openColumnManager={() => setOpenConfig(true)} webSocketChanel = {"TODOAudtisReport"} columns={sortColumn()} messagePath={getMessage} {...props}/>
    </div>);
})

export default AuditReports;